export default "__VITE_ASSET__D1zyWrJh__"